export default __webpack_public_path__ + "static/media/showHideMobile.983497c7.svg";